import {googleAnalytics} from '../utils/track';
import {serializeForm, resetForm} from '../modules/forms';

import '../application';

function subscriptionForm() {
  const subscriptionFormElement = document.querySelector('.js-newsletter-subscription__form');
  const subscriptionFormMessageElement = document.querySelector('.js-newsletter-subscription__form-submit-message');
  const subscriptionEmailInputElement = document.querySelector('.js-newsletter-subscription__form-input');
  const messages = {
    invalidEmail: 'Please enter a valid email',
    success: 'Thanks for subscribing.',
    systemError: 'Something went wrong, please try again later.',
  };

  /**
   * Validates if email matches a valid email pattern
   * @param {String} email Email to validate
   */
  function isEmailValid(email) {
    const emailPattern =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return email.trim().length > 0 && emailPattern.test(email.trim());
  }

  /**
   * Clears form response messaging in the UI
   */
  function clearMessage() {
    subscriptionFormMessageElement.classList.remove('error', 'success');
    subscriptionFormMessageElement.textContent = '';
  }

  /**
   * Displays proper messaging and class for the form status message
   * @param {String} status Either 'success' or 'error
   * @param {String} message The message to display
   */
  function handleMessage(status, message) {
    subscriptionFormMessageElement.classList.add(status);
    subscriptionFormMessageElement.textContent = message;

    // Send analytics events to Google Analytics
    googleAnalytics({
      eventCategory: 'Plus Blog',
      eventAction: 'Newsletter subscription',
      eventLabel: status,
    });
  }

  function handleError(message) {
    handleMessage('error', message);
    subscriptionEmailInputElement.setAttribute('aria-invalid', true);
    subscriptionEmailInputElement.focus();
  }

  function handleSuccess(message) {
    handleMessage('success', message);
    resetForm(subscriptionFormElement);
    subscriptionEmailInputElement.setAttribute('aria-invalid', false);
  }

  function handleFormSubmit() {
    subscriptionFormElement.addEventListener('submit', (event) => {
      event.preventDefault();
      clearMessage();

      // Doing client side validation for email here, since we don't yet have
      // proper error handling in the controller
      if (isEmailValid(subscriptionFormElement.email.value)) {
        const endpoint = subscriptionFormElement.getAttribute('action');
        const serializedFormData = serializeForm(subscriptionFormElement);
        const xhr = new XMLHttpRequest();

        xhr.onload = () => {
          subscriptionFormElement.removeAttribute('aria-busy');

          // Process our return data
          if (xhr.status >= 200 && xhr.status < 300) {
            handleSuccess(messages.success);
          } else {
            handleError(messages.systemError);
          }
        };

        if (!subscriptionFormElement.getAttribute('aria-busy')) {
          // Set a flag on the form that disables further submissions until the current ajax request is complete...
          subscriptionFormElement.setAttribute('aria-busy', true);

          xhr.open('POST', `${endpoint}.json`);
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          xhr.send(serializedFormData);
        }
      } else {
        handleError(messages.invalidEmail);
      }
    });
  }

  if (subscriptionFormElement) {
    handleFormSubmit();
  }
}

function shareWidget() {
  const shareLinks = [...document.getElementsByClassName('js-share-widget__icon')];

  shareLinks.forEach((shareLink) => {
    if (shareLink.dataset.platform === 'email') {
      return;
    }

    shareLink.addEventListener('click', (event) => {
      event.preventDefault();
      window.open(
        shareLink.href,
        `${shareLink.dataset.platform}`,
        'width=510, height=680, resizable, scrollbars, status',
      );

      // Send analytics events to Google Analytics
      googleAnalytics({
        eventCategory: 'Plus Blog',
        eventAction: 'Article share link clicked',
        eventLabel: shareLink.dataset.platform,
      });
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  subscriptionForm();
  shareWidget();
});
